<template>
    <div class="pay-container" v-if="show">
        <div class="pay-logo"></div>
        <div class="pay-step-2">
            <div class="pay-2-warpper">
                <div class="pay-2-box">
                    <div class="left">
                        <div class="left-box">
                            <div class="pay-2t1">欢迎部署穿搭私域小程序系统</div>
                            <div class="pay-2t2">
                                <div>请准备好以下资料，方便下一步进行小程序注册、认证及政府备案</div>
                            </div>
                            <div class="pay-2t3">
                                <div>① 主体营业照片</div>
                                <div>② 营业执照法人身份证正反面照片</div>
                                <div>③ 公司营业执照准备开户银行账号信息（账号、开户行）
                                    <div>个人营业执照准备个人银行卡信息（卡号、开户行）</div>
                                </div>
                                <div>④ 法人本人需要下一步注册、认证、备案过程中途配合
                                    <div>进行手机端人脸身份核验</div>
                                </div>
                            </div>
                            <div class="pay-2t4">
                                
                                <div @click="gotoReg" class="reg-btn" :class="{disabled: readTime > 0}">
                                    <span>开始注册</span>
                                    <template v-if="readTime > 0 "> ({{ readTime }})</template>
                                </div>
                                
                                <div class="pay-tips">*SaaS软件特殊性开通后不支持退款</div>
                            </div>
                            <div class="pay-2t5">
                                <div>
                                    <span>根据腾讯公司《微信小程序官方政策》，开通小程序及以后每年均须进行小程序认证</span>
                                </div>
                                <div>
                                    <span>企业公司主体：300元,<span class="sp1"></span>个体工商户主体：30元</span>
                                </div>
                                <div>
                                    <span>(该费用在小程序认证环节由腾讯公司收取)</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-if="isShowOfficial" class="official-container">
            <div class="official-wrapper">
                <div class="official-header">
                    请微信扫码关注下方公众号，方便注册认证备案进度信息 <br>通过<span>微信消息方式</span>提醒你
                </div>
                <div class="official-content">
                    <img
                        src="https://static.ycsd.work/collocation-helper/static/images/qrcode_for_gh_4ed4ec438efb_430.jpg"
                        alt="">
                    <div class="qrcode-name">请超级管理员微信扫码关注</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import api from "@/repo/api";

export default {
    props: {
        tipsKey: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            step: 0,
            readTime: 30,
            error: false,
            parentInfo: undefined,
            qrcodeBase64: null,
            payInfo: {},
            timerFlag: 0,
            show: true,
            isShowOfficial: false,
        }
    },
    mounted() {
        this.init()
    },
    destroyed() {
        clearTimeout(this.timerFlag)
    },
    methods: {
        init() {
            this.fetchStatus()
        },
        async fetchStatus() {
            
            const func = () => {
                
                api.post('/ast-app/is-bind-wechat-official-account').then(data => {
                    
                    this.isShowOfficial = !data.data.is_bind
                    
                    if (data.data.is_bind) {
                        clearInterval(this.timerFlag)
                        this.begin()
                    }
                    
                });
                
            }
            
            this.timerFlag = setInterval(func, 5000)
            
            func()
            
        },
        gotoReg() {
            
            if (this.readTime > 0) return;
            
            this.show = false
            
            if (this.tipsKey) localStorage[this.tipsKey] = 1;
        },
        begin() {
            this.readTime = 30;
            this.step = 2;
            this.countDown()
        },
        countDown() {
            setTimeout(() => {
                
                this.readTime--;
                
                if (this.readTime > 0) this.countDown()
                
            }, 1000)
        }
    }
}
</script>

<style scoped lang="scss">
.pay-container {
    background-image: url("https://static.ycsd.work/collocation-helper/ast/yc-reg-bg.jpg");
    background-color: white;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
}

.pay-2-warpper {
    position: absolute;
    top: 240px;
    left: 223px;
    width: 587px;
    height: 510px;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0 4px 12px 0 rgba(3, 3, 3, 0.2);
    border-radius: 0 0 0 0;
    padding: 48px;
    font-size: 14px;
    line-height: 14px;
}

.pay-2t1 {
    font-weight: 500;
    font-size: 24px;
    line-height: 34px;
    font-style: normal;
    text-transform: none;
    color: #435A86;
    text-align: left;
    
}

.pay-2t2 {
    color: #666666;
    margin-top: 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
}

.pay-2t3 {
    margin-top: 32px;
    
    div {
        margin-top: 12px;
        line-height: 20px;
    }
}

.pay-2t4 {
    margin-top: 32px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
}

.pay-tips {
    color: #FBB03B;
    text-align: left;
    font-style: normal;
    margin-left: 12px;
}

.reg-btn {
    width: 240px;
    height: 40px;
    background: #333333;
    border-radius: 0;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    cursor: pointer;
}

.pay-2t5 {
    margin-top: 17px;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    
    > div {
        margin-top: 8px;
        
        &:first-child {
            margin-top: 0;
        }
    }
}

.sp1 {
    display: inline-block;
    width: 30px;
}

.official-container {
    position: absolute;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.2);
}

.official-wrapper {
    position: absolute;
    width: 604px;
    height: 490px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 24px;
}

.official-header {
    font-weight: 400;
    font-size: 18px;
    color: #000000;
    line-height: 30px;
    border-bottom: 1px solid #EEEEEE;
    text-align: center;
    margin-top: 24px;
    padding-bottom: 16px;
    
    span {
        color: #465884;
    }
}

.official-content {
    padding-top: 40px;
    text-align: center;
    
    img {
        width: 240px;
        height: 240px;
    }
    
    .qrcode-name {
        font-weight: 600;
        font-size: 24px;
        color: #333333;
        letter-spacing: 1px;
    }
}

</style>